import { ActiveHeaderButtonModel } from "../interfaces";
import { action } from "easy-peasy";

export const ActiveHeaderButton: ActiveHeaderButtonModel = {
  activeButton: "",
  setActiveButton: action((state, payload) => {
    state.activeButton = payload;
  }),
  loginFlow: {
    showTooltip: false,
    tooltipTitle: "",
    tooltipText: "",
    metadata: null,
  },
  setLoginFlow: action((state, payload) => {
    state.loginFlow = payload;
  }),
  clearLoginFlow: action((state) => {
    state.loginFlow = {
      showTooltip: false,
      tooltipTitle: "",
      tooltipText: "",
      metadata: null,
    };
  }),
};
